import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth
export const login = async (email) => {
  const response = await api.post('/auth/login', { email });
  return response.data;
};

export const checkAuth = async (email) => {
  const response = await api.get('/auth/check', { params: { email } });
  return response.data;
};

// PIs
export const getPIs = async () => {
  const response = await api.get('/pis');
  return response.data;
};

export const createPI = async (data) => {
  const response = await api.post('/pis', data);
  return response.data;
};

export const getPI = async (id) => {
  const response = await api.get(`/pis/${id}`);
  return response.data;
};

export const updatePI = async (id, data) => {
  const response = await api.put(`/pis/${id}`, data);
  return response.data;
};

export const deletePI = async (id) => {
  const response = await api.delete(`/pis/${id}`);
  return response.data;
};

// PI enrichment / demographics
export const extractPIFromCV = async (id, force = false) => {
  const response = await api.post(`/pis/${id}/extract-from-cv`, null, {
    params: { force },
    timeout: 60000,
  });
  return response.data;
};

export const refreshPIDemographics = async (id, force = true) => {
  const response = await api.post(`/pis/${id}/refresh-demographics`, null, {
    params: { force },
    timeout: 60000,
  });
  return response.data;
};

// Documents
export const getDocuments = async (docType = null) => {
  const params = docType ? { doc_type: docType } : {};
  const response = await api.get('/documents', { params });
  return response.data;
};

export const uploadDocument = async (file, docType, piId = null, name = null) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('doc_type', docType);
  if (piId) formData.append('pi_id', piId);
  if (name) formData.append('name', name);
  
  const response = await api.post('/documents', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getDocument = async (id) => {
  const response = await api.get(`/documents/${id}`);
  return response.data;
};

export const deleteDocument = async (id) => {
  const response = await api.delete(`/documents/${id}`);
  return response.data;
};

// Feasibilities
export const getFeasibilities = async (status = null) => {
  const params = status ? { status } : {};
  const response = await api.get('/feasibilities', { params });
  return response.data;
};

export const createFeasibility = async (data) => {
  const response = await api.post('/feasibilities', data);
  return response.data;
};

export const getFeasibility = async (id) => {
  const response = await api.get(`/feasibilities/${id}`);
  return response.data;
};

export const updateFeasibility = async (id, data) => {
  const response = await api.put(`/feasibilities/${id}`, data);
  return response.data;
};

export const deleteFeasibility = async (id) => {
  const response = await api.delete(`/feasibilities/${id}`);
  return response.data;
};

export const generateResponses = async (id, questionIds = null) => {
  const response = await api.post(`/feasibilities/${id}/generate`, { question_ids: questionIds });
  return response.data;
};

export const submitFeedback = async (id, questionId, editedText) => {
  const response = await api.post(`/feasibilities/${id}/feedback`, {
    question_id: questionId,
    edited_text: editedText,
  });
  return response.data;
};

export const completeFeasibility = async (id) => {
  const response = await api.post(`/feasibilities/${id}/complete`);
  return response.data;
};

// Demographics
export const getDemographics = async (location) => {
  const response = await api.get(`/demographics/${encodeURIComponent(location)}`);
  return response.data;
};

// Question Parsing
export const parseQuestions = async (text) => {
  const formData = new FormData();
  formData.append('text', text);
  const response = await api.post('/parse-questions', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const parsePDFQuestions = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/parse-pdf-questions', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export default api;
